import React, { useState } from 'react';
import CheckedIcon from "./checkedIcon";

const Checkbox = ({ checked, disabled }) => {
    const [isChecked, setIsChecked] = useState(checked);

    return (
        <div
            className="tw-flex tw-items-center tw-justify-center tw-h-[24px] tw-w-[24px] tw-p-1.5 tw-rounded-md tw-overflow-visible tw-cursor-pointer"
            style={{
                backgroundColor: isChecked ? "#1b2251" : "transparent",
                border: !isChecked ? "2px solid #d5d4d9": null
            }}
        >
            <input
                type="checkbox"
                className="tw-absolute tw-h-[24px] tw-w-[24px] tw-rounded-md tw-cursor-pointer tw-hidden"
                disabled={disabled}
                checked={isChecked}
                onChange={(e) => {
                    setIsChecked(e.currentTarget.checked);
                }}
            />
            <CheckedIcon className="tw-stroke-2 tw-overflow-visible tw-stroke-white"  style={{opacity: isChecked ? 100 : 0}} />
        </div>
    );
};

export default Checkbox;
